import api from '../api/icaro';

// const icaro = {

export async function getStockBalances(locationId, categoryId) {
  const params = {};

  if (locationId) {
    params.location_id = locationId;
  }

  if (categoryId) {
    params.category_id = categoryId;
  }

  const { data } = await api.get('/balances', { params });
  return data;
}

// }

// export default icaro